import React, { useState, useContext, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, FormGroup } from "reactstrap";
import apiHandler from "../../common/config/apiHandler";
import { toast } from "react-hot-toast";
import { inComingNotes } from "../../common/config/socket.service";
import { DataContext } from "../../context/dataContext";

const predefinedNotes = [
  "Voicemail",
  "Not Interested",
  "Callback",
  "Number Incorrect",
  "Hang-up",
  "Complete Later",
  "No Issue",
  "Booked elsewhere",
  "Need To Confirm Details",
  "Looking Prices Only"
];

const CreateNotes = ({ bookingDetails }) => {
  const [show, setShow] = useState(false);
  const [newNote, setNewNote] = useState("");
  
  const { fetchSubscribeKey, subscribeKey } = useContext(DataContext);
  
  useEffect(() => {
    if (bookingDetails) {
      fetchSubscribeKey(
        bookingDetails?.bookingDetails[0]?.company?.sku_tag,
        bookingDetails?.site_id
      );
    }
  }, [bookingDetails]);

  const handleCreateNote = async () => {
    if (!newNote) {
      toast.error("Description cannot be empty.");
      return;
    }

    const user = JSON.parse(localStorage.getItem("user"));
    try {
      const response = await apiHandler({
        endpoint: `/backend/bookingnote`,
        method: "POST",
        data: {
          note: newNote,
          user_id: String(user?.id),
          booking_id: String(bookingDetails?.id),
        },
      });

      if (response?.code === 200) {
        inComingNotes({
          data: { reference_no: bookingDetails?.reference_no },
          token: subscribeKey,
        });
        toast.success("Note created successfully!");
        setNewNote("");
      }
    } catch (error) {
      toast.error("Something went wrong while creating the note.");
      console.error("Error creating note:", error);
    }
  };

  return (
    <>
      <Button color="success" size="sm" className="mb-3 mt-2 mx-4" onClick={() => setShow(true)}>
        Create a New Note
      </Button>

      <Modal isOpen={show} toggle={() => setShow(false)}>
        <ModalHeader toggle={() => setShow(false)}>Create a New Note</ModalHeader>
        <ModalBody style={{ overflowY: "auto" }}>
          <FormGroup>
            <Input
              type="select"
              onChange={(e) => setNewNote(e.target.value)}
              value={newNote}
            >
              <option value="">Select a note</option>
              {predefinedNotes.map((note, index) => (
                <option key={index} value={note}>{note}</option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup>
            <Input
              type="textarea"
              name="newNote"
              id="newNote"
              value={newNote}
              onChange={(e) => setNewNote(e.target.value)}
              placeholder="Write your note here..."
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleCreateNote}>
            Add Note
          </Button>
          <Button color="danger" onClick={() => setShow(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CreateNotes;